import PropTypes from 'prop-types';

import {
  propTypeFontStyle,
  propTypeFontWight,
  propTypeTextDecoration,
  propTypeTextTransform,
} from './basic';

const propTypeStyleTextQuestion = PropTypes.shape({
  color: PropTypes.string,
  fontColor: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  fontStyle: propTypeFontStyle,
  fontWight: propTypeFontWight,
  textDecoration: propTypeTextDecoration,
  textTransform: propTypeTextTransform,
});

export default propTypeStyleTextQuestion;
